<template>
  <div class="resume-library-modal-container" v-if="visible" @click.self="handleClose">
    <!-- 遮罩层 -->
    <div class="resume-library-modal-mask"></div>

    <!-- 弹窗内容 -->
    <div class="resume-library-modal-content" @click.stop>
      <!-- 头部 -->
      <div class="resume-library-header">
        <div class="resume-library-title">选择简历</div>
        <div class="resume-library-close-btn" @click.stop="handleClose">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="resume-library-body">
        <div v-if="resumeList.length === 0" class="empty-state">
          <div class="empty-icon">
            <i class="el-icon-document" style="font-size: 48px; color: #c0c4cc;"></i>
          </div>
          <div class="empty-text">简历库中暂无简历</div>
          <div class="empty-tip">请先上传简历到简历库</div>
          <button class="upload-resume-btn" @click="goToResumeManagement">
            <i class="el-icon-upload"></i>
            上传简历至简历库
          </button>
        </div>
        
        <div v-else class="resume-list">
          <div 
            v-for="(resume, index) in resumeList" 
            :key="index" 
            class="resume-item"
            @click="handleSelect(resume)"
          >
            <div class="resume-info">
              <div class="resume-name">{{ resume.resume_name }}</div>
              <div class="resume-meta">
                <span class="upload-time">上传时间：{{ formatTime(resume.upload_time) }}</span>
                <span class="file-size">文件大小：{{ resume.resume_size }}MB</span>
              </div>
            </div>
            <div class="resume-actions">
              <button class="select-btn">选择</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getResumeList } from '@/api/resume'

export default {
  name: 'ResumeLibraryModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resumeList: []
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadResumeLibrary()
      }
    }
  },
  methods: {
    async loadResumeLibrary() {
      try {
        const response = await getResumeList()
        if (response && response.data && response.data.code === 1) {
          const list = response.data.data || []
          this.resumeList = list.map(item => {
            return { ...item }
          })
        }
      } catch (error) {
        console.error('获取简历库失败:', error)
        this.$message.error('获取简历库失败')
      }
    },
    handleSelect(resume) {
      this.$emit('select', resume)
    },
    handleClose() {
      this.$emit('close')
    },
    goToResumeManagement() {
      this.$emit('close')
      this.$router.push('/store/personal/resume')
    },
    formatTime(val) {
      try {
        let date
        if (typeof val === 'number') {
          // 判断是秒级还是毫秒级时间戳
          // 如果时间戳小于等于10位数，认为是秒级时间戳，需要乘以1000
          const timestamp = val.toString().length <= 10 ? val * 1000 : val
          date = new Date(timestamp)
        } else {
          date = new Date(String(val).replace(/-/g, '/'))
        }
        if (isNaN(date.getTime())) return String(val)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}`
      } catch (e) {
        return String(val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.resume-library-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resume-library-modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
}

.resume-library-modal-content {
  position: relative;
  width: 600px;
  max-width: 90vw;
  max-height: 80vh;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 2001;
}

.resume-library-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.resume-library-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.resume-library-close-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  color: #6b7280;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
    color: #374151;
  }

  svg {
    width: 16px;
    height: 16px;
  }
}

.resume-library-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.empty-icon {
  margin-bottom: 16px;
}

.empty-text {
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.empty-tip {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 24px;
}

.upload-resume-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }

  i {
    font-size: 16px;
  }
}

.resume-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.resume-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
    border-color: #d1d5db;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.resume-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.resume-name {
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
}

.resume-meta {
  display: flex;
  gap: 16px;
  font-size: 14px;
  color: #6b7280;
}

.upload-time,
.file-size {
  display: flex;
  align-items: center;
}

.resume-actions {
  display: flex;
  align-items: center;
}

.select-btn {
  padding: 8px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  }
}

/* 滚动条样式 */
.resume-library-body::-webkit-scrollbar {
  width: 6px;
}

.resume-library-body::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.resume-library-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;

  &:hover {
    background: #94a3b8;
  }
}
</style>

